export default __webpack_public_path__ + "static/media/valvulas.f148dc7e.png";